import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const statusIndicatorVariants = cva(
  "rounded-full flex-shrink-0",
  {
    variants: {
      variant: {
        success: "bg-success-500",
        warning: "bg-warning-500",
        error: "bg-error-500",
        info: "bg-info-500",
        neutral: "bg-neutral-400",
        primary: "bg-primary",
      },
      size: {
        sm: "h-1.5 w-1.5",
        md: "h-2 w-2",
        lg: "h-2.5 w-2.5",
        xl: "h-3 w-3",
      },
    },
    defaultVariants: {
      variant: "neutral",
      size: "md",
    },
  }
);

export interface StatusIndicatorProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof statusIndicatorVariants> {}

function StatusIndicator({ className, variant, size, ...props }: StatusIndicatorProps) {
  return (
    <div
      className={cn(statusIndicatorVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { StatusIndicator, statusIndicatorVariants };
